import { createContext } from 'react';

export const ToastStoreContext = createContext();
